export default __webpack_public_path__ + "images/MP.e114224.png";